import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface mutateProps {
  projectId: string;
  taskId: string;
  data: any
}

const mutateAddQualityCheck = async ({projectId, taskId, data}: mutateProps) => {
  return await axiosAuth.post(`${PROJECT_API}/${projectId}/tasks/${taskId}/quality-checks`, data);
};

const useAddQualityCheckMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateAddQualityCheck,
    ...queryParams,
  });

export default useAddQualityCheckMutation;
